
jQuery(document).ready(function ($) {
  /* eslint-disable */
  const ajaxUrl = _sageAjax.ajaxurl,
    wppid = _sageAjax.pid;
  /* eslint-enable */

  const $isLoggedIn = $('.logged-in').length;

  // /**
  //  * Get User Nav
  //  */
  // if ($isLoggedIn) {
  //   $.ajax({
  //     url: ajaxUrl,
  //     type: 'get',
  //     data: {
  //       'action': 'get_userNav',
  //     },
  //     success: function (response) {
  //       // Append user nav
  //       $('.js-userNav').html(response);

  //       // Bind onclick "Edit in WP" button for editors in userNav
  //       let $wpEditbtn = $('.js-wpEdit');
  //       $wpEditbtn.on('click', function (e) {
  //         e.preventDefault();
  //         window.location = '/wp-admin/post.php?post=' + wppid + '&action=edit';
  //       });
  //     },
  //   });
  // }

  /**
   * Get User Nav Mobile
   */
  if ($isLoggedIn) {
    $.ajax({
      url: ajaxUrl,
      type: 'get',
      data: {
        'action': 'get_userNavMobile',
      },
      success: function (response) {
        // Append user nav
        // console.log(response)
         $('#js-userNav-mobile').html(response);

        // Bind onclick "Edit in WP" button for editors in userNav
        let $wpEditbtn = $('.js-wpEdit');
        $wpEditbtn.on('click', function (e) {
          e.preventDefault();
          window.location = '/wp-admin/post.php?post=' + wppid + '&action=edit';
        });

        // Bind UserNav Close btn
        let $userNavClose = $('#js-userNav-mobile-close'),
          $userNavApi = $('#js-userNav-mobile').data('mmenu');
        $userNavClose.on('click', function (e) {
          e.preventDefault();
          $userNavApi.close();
        });
      }, // end success callback
    });
  }

  /**
   * Get Login Btn
   */
  if (!$isLoggedIn) {
    $.ajax({
      url: ajaxUrl,
      type: 'get',
      data: {
        'action': 'get_loginBtn',
      },
      success: function (response) {
        // Append login btn
        $('.js-loginBtn').html(response);
      },
    });
  }


  /**
   * Set Event Status in Card
   */

  let $events = $(".js-card-event");

  if ($events.length) {
    $.ajax({
      url: '/wonder_event_ajax',
      type: "GET",
      dataType: "json",
      success: function (data) {
        // console.log(data);

        // on loop dans la reponse ajax
        $.map(data, function (value, key) {
          // on loop dans les card-event présentes
          $events.each(function () {
            const $this = $(this),
              $pid = $this.data("pid"),
              $status = $this.find(".js-eventStatus");

            // on append le status à la card correspondante
            if ($pid == key) $status.html(value);
          });
        });
      },
    });
  }



});



// WEBPACK FOOTER //
// ./scripts/autoload/ajax.js